// extracted by mini-css-extract-plugin
module.exports = {"todaysTaskPanel":"top_todaysTaskPanel__3DfNz"};